import { render, staticRenderFns } from "./custom_detail.vue?vue&type=template&id=4f5c15f2&scoped=true"
import script from "./custom_detail.vue?vue&type=script&lang=js"
export * from "./custom_detail.vue?vue&type=script&lang=js"
import style0 from "./custom_detail.vue?vue&type=style&index=0&id=4f5c15f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c15f2",
  null
  
)

export default component.exports